import { useState, Fragment } from 'react';
import ResourcesButtonGroup from './common/ResourcesButtonGroup';
import { FormattedMessage, injectIntl } from 'react-intl';
import './common/Resources.scss';
import { resources, getSelectedMarketingMaterials } from './helpers';

const MarketingResourcesWrapper = () => {
  const [selectedOption, setActiveIndex] = useState(1);
  const handleButtonClick = (option) => setActiveIndex(option);

  const resolveButtonLabel = (type) => {
    switch (type) {
      case 'link':
        return 'Open';
      case 'video':
        return 'Turn on';
      default:
        return 'Download';
    }
  };

  const renderSelectedResource =
    selectedOption &&
    getSelectedMarketingMaterials(selectedOption)?.map(({ hero, intro, links, id }) => (
      <Fragment key={id}>
        <div className='marketing__hero'>
          <p>
            <FormattedMessage id={intro} />
          </p>
          <img src={hero} alt='' />
        </div>

        {links.map(({ label, url, type, description }, index) => (
          <div className='marketing__boxes' key={index}>
            <p>
              <span>
                <FormattedMessage id={label} />
                {description ? (
                  <span>
                    <FormattedMessage id={description} />
                  </span>
                ) : null}
              </span>

              <a href={url} target='_blank' rel='noopener noreferrer'>
                <FormattedMessage id={resolveButtonLabel(type)} />
              </a>
            </p>
          </div>
        ))}
      </Fragment>
    ));

  return (
    <div className='marketing-resources'>
      <ResourcesButtonGroup options={resources} selected={selectedOption} handleButtonClick={handleButtonClick} />
      {selectedOption ? renderSelectedResource : null}
    </div>
  );
};

export default injectIntl(MarketingResourcesWrapper);
